export enum Requirement {
  DEFAULT = "default",
  REQUIRED = "required",
  OPTIONAL = "optional",
  DEPRECATED = "deprecated",
}
